<template>
	<div class="results-none content-section center-block text-center pt-2 bp-8">
		<!-- TODO Image indicating empty results? -->
		<!-- <img v-show="!isMobileMapView" class="mb-2" alt="Image indicating no matching location" /> -->

		<div v-show="!isMobileMapView" class="mb-2">
			<template v-if="hasFilters">
				<p class="results-none-filters large">
					There are no locations nearby that match your filters.
				</p>
				<p class="results-none-filters small mb-3">
					Try a new search, remove your filters or<br />
					<a :href="viewAllClubsUrl">view a list of all locations</a>.
				</p>
			</template>

			<template v-else>
				<p class="results-none-nearby large">There are no locations nearby.</p>
				<p class="results-none-nearby small">
					View the map, try a new search or<br />
					<a :href="viewAllClubsUrl">view a list of all locations</a>.
				</p>
			</template>
		</div>

		<h3 v-show="!isMobileMapView" class="display-5 my-4">Go Digital</h3>

		<div
			class="result-card border-top border-bottom mx-n2 mx-md-0 p-2 d-md-flex gap-2"
			tabindex="0"
		>
			<picture>
				<source
					media="(min-width:992px) and (max-width: 1300px)"
					srcset="
						https://www.lifetime.life/content/dam/ltp/images/locations/geo/ltin20334315-social-share-digital-membership-xs.jpg
					"
				/>
				<img
					alt="Digital Only Membership"
					src="https://www.lifetime.life/content/dam/ltp/images/locations/geo/ltin20334315-social-share-digital-membership-sm.jpg"
					class="result-image rounded-3 mb-1 mb-md-0"
				/>
			</picture>

			<div class="result-body flex-grow-1 d-flex flex-column justify-content-between text-start">
				<div>
					<div class="result-title h3 mb-1">The Life Time App</div>
					<div class="small opacity-75">
						Access complimentary on-demand and live streaming classes, coaching programs, and
						exclusive offers through our world-leading digital platform, completely free to use and
						no longer just for club members.
					</div>
				</div>

				<div class="d-flex justify-content-between align-items-baseline">
					<div class="small opacity-75"></div>
					<a :href="digitalMembershipUrl" class="btn btn-simple btn-icon focus-ring">
						Details <ArrowRightParensIcon />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import ArrowRightParensIcon from 'Lib/icons/ArrowRightParensIcon.vue';
import { getGlobalPageDriverUrl } from '@/util/globalPageDriver';

defineProps<{
	hasFilters: boolean;
	isMobileMapView: boolean;
}>();

const digitalMembershipUrl = getGlobalPageDriverUrl('digitalReferralWelcome');
const viewAllClubsUrl = getGlobalPageDriverUrl('viewAllClubs');
</script>

<style scoped lang="scss">
.results-none {
	.results-none-filters,
	.results-none-nearby {
		margin: 0 2rem;
		padding: 0.25rem 1rem;
	}
}
</style>
